import React from "react";
import { Tooltip as Tooltips } from "@mui/material";
import TungstenRoundedIcon from "@mui/icons-material/TungstenRounded";

const Tooltip = ({ title }) => {
  return (
    <Tooltips title={title ? title : " - "}>
      <TungstenRoundedIcon
        sx={{
          transform: "scaleY(-1)",
          margin: "8px 0",
          color: "#fff",
          background: "#FF9900",
          borderRadius: "100%",
        }}
      />
    </Tooltips>
  );
};
export default Tooltip;
